import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { promotionPiecePopup } from '../functions/onDrop';
@Component({
  selector: 'app-piece-promotion',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './piece-promotion.component.html',
  styleUrl: './piece-promotion.component.scss',
})
export class PiecePromotionComponent implements OnInit {
  promotionpopup = 'popup-hide';

  constructor() {}

  ngOnInit(): void {
    promotionPiecePopup.subscribe((res) => {
      if (res) {
        this.promotionpopup = 'popup-show';
      } else {
        this.promotionpopup = 'popup-hide';
      }
    });
  }
}
